import React from 'react'
import Switch from './Switch'

export default Switch